import React from 'react';
import Loading from '../Loading';
import { LoadingContext } from './useLoadingGroup';
import useLoadingProvider from './useLoadingGroupProvider';

interface LoadingContextProps {
  children: React.ReactNode;
}

const LoadingGroup = ({ children }: LoadingContextProps) => {
  const context = useLoadingProvider();

  return (
    <LoadingContext.Provider value={context}>
      {context.loading && (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(2px)',
          }}
        >
          <Loading />
        </div>
      )}
      {children}
    </LoadingContext.Provider>
  );
};
export default LoadingGroup;
